import React from "react";
// import styled from "@xstyled/styled-components";
import { UpcomingEventsProvider, useUpcomingEventsData } from "../../context/UpcomingEventsContext";
import UpcomingEventsTable from "./UpcomingEventsTable";
import ExportButton from "../../components/ExportButton";
import {
    ContentHeader,
    ContentTitleBlock,
    Chip,
    Subtitle,
    ContentActionsRow,
    BtnIcon,
    TabsNav,
    Tab
} from "../../components/SharedPageStyles";



// import CustomSelect from "../../components/CustomSelect";

const UpcomingEventsContent = () => {
    const { resetData, filteredRows, setAllData, isLoading } = useUpcomingEventsData();

    const economicEvents = filteredRows.filter(row => !(row.Category || "").toUpperCase().includes("EARNINGS"));
    const earningsEvents = filteredRows.filter(row => (row.Category || "").toUpperCase().includes("EARNINGS"));

    const handleReorder = (startIndex, endIndex, subsetRows) => {
        // 1. Create a copy of the subset to reorder
        const reorderedSubset = Array.from(subsetRows);
        const [removed] = reorderedSubset.splice(startIndex, 1);
        reorderedSubset.splice(endIndex, 0, removed);

        // 2. Create a new list for all rows
        // We need to map the global rows to the new order
        // Strategy: Iterate through global rows. If a row belongs to the subset,
        // replace it with the next item from the reordered subset.

        let subsetIndex = 0;
        const newAllRows = filteredRows.map(row => {
            if (subsetRows.includes(row)) {
                const newRow = reorderedSubset[subsetIndex];
                subsetIndex++;
                return newRow;
            }
            return row;
        });

        setAllData(newAllRows);
    };

    const [activeTab, setActiveTab] = React.useState('economic');

    return (
        <>
            <ContentHeader>
                <ContentTitleBlock>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <Chip>Upcoming Events</Chip>
                    </div>
                    <Subtitle>Key economic events, earnings, and policy announcements for the week ahead.</Subtitle>
                </ContentTitleBlock>
            </ContentHeader>

            <ContentActionsRow>
                <BtnIcon
                    onClick={resetData}
                    title="Refresh Data"
                    disabled={isLoading}
                    $spinning={isLoading}
                >
                    ⟳
                </BtnIcon>
                <ExportButton
                    data={activeTab === 'economic' ? economicEvents : earningsEvents}
                    filename={`upcoming_${activeTab}`}
                />
            </ContentActionsRow>

            <TabsNav>
                <Tab
                    active={activeTab === 'economic'}
                    onClick={() => setActiveTab('economic')}
                >
                    Economic Calendar
                </Tab>
                <Tab
                    active={activeTab === 'earnings'}
                    onClick={() => setActiveTab('earnings')}
                >
                    Earnings Calendar
                </Tab>
                {(() => {
                    const activeEvents = activeTab === 'economic' ? economicEvents : earningsEvents;
                    const nextFetchRow = activeEvents.find(r => r.next_fetch);

                    if (nextFetchRow) {
                        return (
                            <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', paddingRight: '4px' }}>
                                <Subtitle style={{ fontSize: '11px', margin: 0 }}>
                                    <em>
                                        Next Fetch: {new Date(nextFetchRow.next_fetch).toLocaleString('en-GB', {
                                            day: '2-digit',
                                            month: '2-digit',
                                            hour: '2-digit',
                                            minute: '2-digit',
                                            hour12: false,
                                            timeZone: 'Europe/Paris'
                                        }).replace(',', '')}
                                    </em>
                                </Subtitle>
                            </div>
                        );
                    }
                    return null;
                })()}
            </TabsNav>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '32px', flex: 1, overflow: 'hidden', minHeight: 0, paddingRight: '8px', marginTop: '16px' }}>
                {activeTab === 'economic' && (
                    <UpcomingEventsTable
                        title="Economic Calendar"
                        data={economicEvents}
                        defaultCategory="Economic Calendar"
                        onReorder={(start, end) => handleReorder(start, end, economicEvents)}
                    />
                )}

                {activeTab === 'earnings' && (
                    <UpcomingEventsTable
                        title="Earnings Calendar"
                        data={earningsEvents}
                        defaultCategory="Earnings Calendar"
                        onReorder={(start, end) => handleReorder(start, end, earningsEvents)}
                    />
                )}
            </div>
        </>
    );
};

const UpcomingEvents = () => {
    return (
        <UpcomingEventsProvider>
            <UpcomingEventsContent />
        </UpcomingEventsProvider>
    );
};

export default UpcomingEvents;
